import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {LinkSchema} from './link'

export const LinkGroupSchema = buildEntrySchemaFor('linkGroup', {
  fields: z.lazy(() =>
    z.object({
      label: z.string(),
      links: z.array(LinkSchema),
    }),
  ),
})

export type LinkGroup = z.infer<typeof LinkGroupSchema>

export function isLinkGroup(entry: unknown): entry is LinkGroup {
  return LinkGroupSchema.safeParse(entry).success
}
